import React from 'react'
import {Nullable} from '../../../Common/TypeHelper'

type PhoneInformationProps = {
  mobile?: Nullable<string>
  home?: Nullable<string>
}

export const PhoneInformation: React.VFC<PhoneInformationProps> = ({mobile, home}) => {
  if (mobile && home) {
    return <>(携帯) {mobile}<br/>(固定) {home}</>
  }
  if (mobile) {
    return <>(携帯) {mobile}</>
  }
  if (home) {
    return <>(固定) {home}</>
  }

  return <></>
}
